module.exports = __webpack_public_path__ + "static/media/ic_circle_arrow_right.47a79204.svg";